<template>
  <div class="ut-card-base ut-flex flex-wrap md:ut-justify-between ut-mb-6 ut-text-center md:ut-text-left ut-px-3 md:ut-px-6">
      <section class="md:ut-flex ut-justify-start ut-m-0 ut-w-full">
        <figure class="ut-rounded-full ut-border ut-border-solid">
          <svg-icon :icon="'icon-listing'"
                    :size="17"
                    :addClass="''"></svg-icon>
        </figure>
        <div class="ut-m-0" data-oa-name="wrapper-won-listings">
          <h3>Won listings</h3>
          <p data-oa-name="stat">{{ groupStats.wonListingRate | percentage }}</p>
        </div>
      </section>
      <section class="md:ut-flex ut-justify-start ut-m-0 ut-w-full">
        <figure class="ut-rounded-full ut-border ut-border-solid">
          <svg-icon :icon="'icon-watch'"
                    :size="17"
                    :addClass="''"></svg-icon>
        </figure>
        <div class="ut-m-0" data-oa-name="wrapper-first-attempt">
          <h3>First attempt</h3>
          <p data-oa-name="stat">{{ groupStats.medianMinutesFirstAttempt | formatDuration }}</p>
        </div>
      </section>
      <section class="md:ut-flex ut-justify-start ut-m-0 ut-w-full">
        <figure class="ut-rounded-full ut-border ut-border-solid">
          <svg-icon :icon="'icon-phone'"
                    :size="17"
                    :addClass="''"></svg-icon>
        </figure>
        <div class="ut-m-0" data-oa-name="wrapper-contact">
          <h3>Contact</h3>
          <p data-oa-name="stat">{{ groupStats.medianMinutesFirstContact | formatDuration }}</p>
        </div>
      </section>
      <section class="md:ut-flex ut-justify-start ut-m-0 ut-w-full">
        <figure class="ut-rounded-full ut-border ut-border-solid">
          <svg-icon :icon="'icon-check'"
                    :size="17"
                    :addClass="''"></svg-icon>
        </figure>
        <div class="ut-m-0" data-oa-name="wrapper-successful-contact">
          <h3>Successful contact</h3>
          <p data-oa-name="stat">{{ groupStats.successfulContactRate | percentage }}</p>
        </div>
      </section>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue';

export default {
  name: 'PerformanceAgencyGroupStats',
  components: {
    SvgIcon,
  },
  props: {
    groupStats: {
      required: true,
      default: null,
    },
  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
  figure {
    @apply ut-flex ut-items-center ut-justify-center ut-m-auto ut-mb-3;
    border-color: #99E0AD;
    color: #00AB64;
    height: 30px;
    width: 30px;

    @screen md {
     @apply ut-m-0 ut-mr-4;
      height: 49px;
      width: 49px;
    }
  }

  p {
    color: #233A3A;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.34px;
    line-height: 36px;

    @screen md {
      font-size: 24px;
    }
  }

  h3 {
    opacity: 0.6;
    color: #233A3A;
    font-size: 14px;
    line-height: 16px;

    @apply ut-h-10;

    @screen md {
      @apply ut-h-auto;
    }
  }
</style>
